<template>
  <section class="mx-auto flex min-h-[70vh] max-w-3xl flex-col gap-6 px-6 py-16">
    <div class="rounded-3xl border border-white/10 bg-midnight-800/60 p-6 shadow-glow sm:p-8">
      <div class="flex flex-col gap-2">
        <p class="text-xs uppercase tracking-[0.35em] text-steel-400">Support</p>
        <h1 class="font-display text-3xl font-semibold text-white">Report a Site Issue</h1>
        <p class="text-sm text-steel-300">
          Tell us what went wrong. The admin team will review it in the dashboard.
        </p>
      </div>

      <form class="mt-6 space-y-5" @submit.prevent="submitReport">
        <label class="block text-sm text-steel-200">
          Category
          <select
            v-model="category"
            class="mt-2 w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"
          >
            <option value="bug">Bug</option>
            <option value="performance">Performance</option>
            <option value="ui">UI / Layout</option>
            <option value="account">Account</option>
            <option value="other">Other</option>
          </select>
        </label>

        <label class="block text-sm text-steel-200">
          What happened?
          <textarea
            v-model.trim="description"
            rows="6"
            maxlength="1000"
            placeholder="Describe the issue, steps to reproduce, and what you expected."
            class="mt-2 w-full resize-none rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-500 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"
          ></textarea>
        </label>

        <label class="block text-sm text-steel-200">
          Page URL (auto-filled)
          <input
            v-model.trim="pageUrl"
            type="text"
            class="mt-2 w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-500 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"
            placeholder="https://"
          />
        </label>

        <div class="flex flex-wrap items-center gap-3">
          <button
            type="submit"
            class="rounded-2xl bg-white px-6 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-neon-400 disabled:cursor-not-allowed disabled:opacity-70"
            :disabled="submitting || !description"
          >
            {{ submitting ? 'Sending...' : 'Send report' }}
          </button>
          <p v-if="statusMessage" class="text-sm text-neon-300">{{ statusMessage }}</p>
          <p v-if="errorMessage" class="text-sm text-rose-200">{{ errorMessage }}</p>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { supabase } from '@/lib/supabase'

export default {
  name: 'ReportIssueView',
  data() {
    return {
      userId: '',
      category: 'bug',
      description: '',
      pageUrl: '',
      submitting: false,
      statusMessage: '',
      errorMessage: '',
    }
  },
  async mounted() {
    const { data } = await supabase.auth.getSession()
    const user = data?.session?.user
    if (!user) {
      this.$router.push('/login')
      return
    }
    this.userId = user.id
    this.pageUrl = window.location.href
  },
  methods: {
    async submitReport() {
      if (!this.userId) {
        this.errorMessage = 'Please sign in to report an issue.'
        return
      }
      if (!this.description) return

      this.submitting = true
      this.errorMessage = ''
      this.statusMessage = ''

      const { error } = await supabase.from('site_reports').insert({
        user_id: this.userId,
        category: this.category,
        description: this.description,
        page_url: this.pageUrl,
        status: 'open',
      })

      this.submitting = false

      if (error) {
        this.errorMessage = error.message || 'Unable to send report.'
        return
      }

      this.description = ''
      this.statusMessage = 'Report sent. Thank you.'
      setTimeout(() => (this.statusMessage = ''), 2500)
    },
  },
}
</script>
